var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNotification = function SvgIconNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M18.3 9.219c0-2.857-2.044-5.263-4.83-5.992-.154-.814-.904-1.426-1.77-1.426-.867 0-1.59.61-1.762 1.424C7.148 3.95 5.1 6.359 5.1 9.219v6.682H3.9a.9.9 0 1 0 0 1.8h15.6a.9.9 0 0 0 0-1.8h-1.2zM11.7 21.6c-1.32 0-2.4-1.113-2.4-2.4h4.8c0 1.287-1.08 2.4-2.4 2.4"
  })));
};
export default SvgIconNotification;